import React, { useState } from 'react';
import {
  Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#F8FAFC',
    }}>
      <Card sx={{
        maxWidth: 400,
        width: '100%',
        mx: 2,
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 6px 16px rgba(0,0,0,0.04)',
        border: '1px solid #E2E8F0',
      }}>
        <CardContent sx={{ p: 4 }}>
          {/* Brand */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box
              component="img"
              src="/logo192.png"
              alt="Kovil"
              sx={{ width: 52, height: 52, mb: 1, borderRadius: '12px' }}
            />
            <Typography sx={{
              fontSize: 26,
              fontWeight: 700,
              color: '#0F172A',
              letterSpacing: '-0.02em',
              lineHeight: 1.2,
            }}>
              Kovil <Box component="span" sx={{ fontWeight: 500, color: '#64748B' }}>Timesheet</Box>
            </Typography>
          </Box>

          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 2,
                borderRadius: '8px',
                fontSize: 13,
              }}
            >
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username / UID"
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                },
              }}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                mt: 2.5,
                height: 44,
                borderRadius: '8px',
                fontSize: 14,
                fontWeight: 600,
                textTransform: 'none',
                bgcolor: '#3B82F6',
                '&:hover': {
                  bgcolor: '#2563EB',
                },
              }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Sign in'}
            </Button>
          </Box>

          <Typography sx={{
            textAlign: 'center',
            mt: 3,
            fontSize: 11.5,
            color: '#CBD5E1',
            fontWeight: 400,
          }}>
            Kovil Ventures
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
